// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"slug_wrapper__3DP8K","grid":"slug_grid__o9Rdh","main":"slug_main__ECWPa"};